import { addDays, addWeeks, format, parseISO } from 'date-fns'
import type { Aanstelling } from './medewerker-types'
import type { Semester, Sleutels } from './semester-types'

const WEKEN_PER_JAAR = 52

export function maandagenIn(van: string, tot: string): string[] {
  const start = parseISO(van)
  const eersteMaandag = addDays(start, (8 - (start.getDay() === 0 ? 7 : start.getDay())) % 7)

  const maandagen: string[] = []
  let cursor = eersteMaandag
  while (format(cursor, 'yyyy-MM-dd') <= tot) {
    maandagen.push(format(cursor, 'yyyy-MM-dd'))
    cursor = addWeeks(cursor, 1)
  }

  return maandagen
}

export function semesterWeken(semester: Semester): number {
  return maandagenIn(semester.startDatum, semester.eindDatum).length
}

export function geldigOp(aanstelling: Aanstelling, datum: string): boolean {
  if (datum < aanstelling.geldigVan) return false
  return aanstelling.geldigTot === null || datum <= aanstelling.geldigTot
}

export function nettoFteOp(aanstellingen: Aanstelling[], datum: string): number | null {
  const geldig = aanstellingen.find((aanstelling) => geldigOp(aanstelling, datum))
  return geldig ? geldig.nettoFte : null
}

export function urenPerSemester(
  aanstelling: Aanstelling,
  semester: Semester,
  sleutels: Sleutels | null,
): number | null {
  if (!sleutels) return null

  const weken = maandagenIn(semester.startDatum, semester.eindDatum).filter((maandag) =>
    geldigOp(aanstelling, maandag),
  ).length

  return (aanstelling.nettoFte * sleutels.fteUrenPerJaar * weken) / WEKEN_PER_JAAR
}

export function nettoFte(brutoFte: number, detacheringFte: number, wtvFte: number): number {
  return Math.max(0, brutoFte - detacheringFte - wtvFte)
}
